import PropTypes from "prop-types";
import { PAYMENT_METHODS, PAYMENT_TERMS } from "app/constants";
import "./PaymentMethodsFieldsetNew.scss";
import PaymentTypeInput from "app/pages/Booking/Payment/PaymentData/PaymentDataModeFirst/PaymentMethodsFieldsetNew/PaymentTypeInput";
import CreditCardPaymentType from "app/pages/Booking/Payment/PaymentData/PaymentDataModeFirst/PaymentMethodsFieldsetNew/creditCard/CreditCardPaymentType";
import { paymentTypeShape, paymentTypesValues } from "app/utils/propTypes";
import { FormattedMessage } from "react-intl";
import CreditCardPictos from "app/pages/.shared/CreditCardPictos/CreditCardPictos";

const PaymentMethodsFieldsetNew = ({
	onChange,
	allowedPaymentTypes = [],
	ideal = {},
	onCreditCardInputsBlur,
	onAdyenComponentMounted,
	total,
	mensualite2Fois = {},
	swissbilling = { forbiddenCause: "", cgvURL: "" },
	selectedPaymentType,
}) => {
	const useAdyen = selectedPaymentType !== PAYMENT_METHODS.CARD_CSE;

	if (allowedPaymentTypes.length > 1) {
		return (
			<div className="payment-methods-fieldset-new">
				<div>
					{allowedPaymentTypes.map(allowedPaymentType => {
						return (
							<div
								className="payment-methods-fieldset-new__item"
								key={allowedPaymentType.paymentType + allowedPaymentType.terms}
							>
								<PaymentTypeInput
									swissbilling={swissbilling}
									total={total}
									mensualite2Fois={mensualite2Fois}
									paymentType={allowedPaymentType}
									onChange={onChange}
									ideal={ideal}
									onCreditCardInputsBlur={onCreditCardInputsBlur}
									onAdyenComponentMounted={onAdyenComponentMounted}
								/>
							</div>
						);
					})}
				</div>
			</div>
		);
	} else if (allowedPaymentTypes.length === 1) {
		let acceptedCreditCardTypes = allowedPaymentTypes[0].acceptedCreditCardTypes;

		const creditCardIcons = <CreditCardPictos creditCardCodes={acceptedCreditCardTypes} />;

		if (allowedPaymentTypes[0].terms === PAYMENT_TERMS["1x"]) {
			return (
				<div className="payment-methods-fieldset-new payment-methods-fieldset-new--single">
					{!useAdyen && (
						<div className="payment-methods-fieldset-new__line">
							<FormattedMessage id="payment.method.adyen_cse_card" />
							{creditCardIcons}
						</div>
					)}
					<CreditCardPaymentType
						useAdyen={useAdyen}
						payNowAmount={total}
						onAdyenComponentMounted={onAdyenComponentMounted}
						onCreditCardInputsBlur={onCreditCardInputsBlur}
					/>
				</div>
			);
		} else if (allowedPaymentTypes[0].terms === PAYMENT_TERMS["2x"]) {
			return (
				<div className="payment-methods-fieldset-new payment-methods-fieldset-new--single">
					{!useAdyen && (
						<div className="payment-methods-fieldset-new__line">
							<FormattedMessage id="payment.method.adyen_cse_card" />
							{creditCardIcons}
						</div>
					)}
					<CreditCardPaymentType
						useAdyen={useAdyen}
						payNowAmount={mensualite2Fois.payNowAmount}
						payLaterAmount={mensualite2Fois.payLaterAmount}
						dueDate={mensualite2Fois.dueDate}
						onAdyenComponentMounted={onAdyenComponentMounted}
						onCreditCardInputsBlur={onCreditCardInputsBlur}
					/>
				</div>
			);
		}
	}

	return false;
};

PaymentMethodsFieldsetNew.propTypes = {
	fields: PropTypes.object,
	onCreditCardInputsBlur: PropTypes.func,
	onAdyenComponentMounted: PropTypes.func,
	onChange: PropTypes.func,
	allowedPaymentTypes: PropTypes.arrayOf(paymentTypeShape),
	total: PropTypes.number,
	mensualite2Fois: PropTypes.object,
	swissbilling: PropTypes.object,
	ideal: PropTypes.object,
	selectedPaymentType: paymentTypesValues,
};

export default PaymentMethodsFieldsetNew;
